import { SitecoreContextValue } from '@sitecore-jss/sitecore-jss-react';
import { Components } from '.generated/templates/Feature.Components.constants';

/**
 * Interface for component with componentName property
 */
interface ComponentWithName {
  componentName: string;
  [key: string]: unknown;
}

/**
 * Determines if the current page contains an EmployeeBlogListing component
 * @param sitecoreContext - The Sitecore context object
 * @returns the component template ID if found, null otherwise
 */
export const isEmployeeBlog = (sitecoreContext: SitecoreContextValue): string | null => {
  const { route } = sitecoreContext;
  // Check specifically in the nmdp-main placeholder for the EmployeeBlogListing component
  const nmdpMainComponents = route?.placeholders?.['nmdp-main'];

  if (Array.isArray(nmdpMainComponents)) {
    const employeeBlogComponent = nmdpMainComponents.find((component) => {
      const foundComponent = component as ComponentWithName;
      return foundComponent.componentName === 'EmployeeBlogListing';
    });

    if (employeeBlogComponent) {
      return Components.TemplateIds.EmployeeBlogListing;
    }
  }

  return null;
};
